import { useQuery } from "react-query";
import { Auth } from "shared/@auth/Auth";

export function useUsersData() {
  const { makeAuthedRequest } = Auth.useContainer();

  const { data, status, refetch } = useQuery(["users"], () =>
    makeAuthedRequest(`/dreamstream/users`, {
      method: "GET",
    }).then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  return {
    data,
    status,
    refetch,
  };
}
